import React from "react";
import RichText from "./RichText";
export default function ArticleSection(props) {
  return (
    <div className="city-state-container article-source">
      <h1> {props?.ArticleSection?.content?.Header[0]?.headline}</h1>
      <RichText
        Description={
          props?.ArticleSection?.content?.Media_Object_Group[0]?.Description
        }
      />
    </div>
  );
}
